export default "__VITE_ASSET__BsZyp5Kp__"